import {NgModule} from '@angular/core';
import {SharedModule} from '../../../core/shared.module';
import {ArticleWizardButtonComponent} from './article-wizard-button.component';
import {ArticleWizardCreateModalComponent} from './article-wizard-create-modal.component';

@NgModule({
  imports: [
    SharedModule,
  ],
  declarations: [
    ArticleWizardButtonComponent,
    ArticleWizardCreateModalComponent,
  ],
  exports: [
    ArticleWizardButtonComponent,
  ],
})
export class ArticleWizardButtonModule {
}
